import type { GetFilesPayload } from '../../interfaces/FileApiService';
import { FilesTableEnum } from '../../enums/FilesTableEnum';

/**
 * Maps the active files table to default `list` / `type` payload fields for `getFiles`.
 *
 * @param table - Files section (personal, received, trash, etc.).
 * @returns Partial payload fragment merged into list request state.
 */
export function getPartialFiltersBasedOnTable(
  table: FilesTableEnum,
): Pick<GetFilesPayload, 'list' | 'type'> {
  switch (table) {
    case FilesTableEnum.Personal:
      return { list: 0, type: 2 };
    case FilesTableEnum.Received:
      return { list: 0, type: 1 };
    case FilesTableEnum.Shared:
      return { list: 4, type: 2 };
    case FilesTableEnum.Favorites:
      return { list: 2, type: 2 };
    case FilesTableEnum.Recent:
      // Unused by GET /myfiles/recent; kept so filter state stays typed.
      return { list: 1, type: 2 };
    case FilesTableEnum.Hidden:
      return { list: 3, type: 2 };
    case FilesTableEnum.Trash:
      return { list: 5, type: 2 };
    default:
      return { list: 0, type: 2 };
  }
}
